import { render, staticRenderFns } from "./CoozzyUserCogIcon.vue?vue&type=template&id=80341400&scoped=true"
import script from "./CoozzyUserCogIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyUserCogIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyUserCogIcon.vue?vue&type=style&index=0&id=80341400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80341400",
  null
  
)

export default component.exports